import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import { DECORATION_RECOMMEND_WINDOW } from '@constant'

class Item extends Component {
  render() {
    const {
      item: { image_info }
    } = this.props

    if (!image_info) return null

    const { show_type, posters } = image_info
    return (
      <div
        style={
          show_type == 1
            ? {
                width: '362px',
                margin: '0 0 0 -6px'
              }
            : {
                width: '100%'
              }
        }
      >
        {(posters || []).map((item, index) => {
          let props =
            show_type == 1
              ? {
                  width: '167px',
                  borderRadius: '12px',
                  margin: '5px 6px'
                }
              : {
                  width: '100%',
                  borderRadius: '12px',
                  margin: '5px 0'
                }

          return <img style={props} src={item.image_path} key={index} />
        })}
      </div>
    )
  }
}

@observer
export default class extends Component {
  static displayName = 'RecommendWindow'
  componentDidMount() {
    this.props.store.getWindowList()
  }

  render() {
    const { recommendWindow, mode } = this.props.store
    const { list, total_count } = recommendWindow
    const hasRecommendWindow = total_count > 0
    const isModuleShow =
      mode === 'editable' || (mode === 'preview' && hasRecommendWindow)

    return isModuleShow ? (
      <Rowbox
        type={DECORATION_RECOMMEND_WINDOW}
        store={this.props.store}
        style={{
          height: 'auto',
          flexDirection: 'column',
          padding: '15px 12px',
          minHeight: 92
        }}
        vCenter={false}
      >
        {hasRecommendWindow ? (
          <div>
            {(list || []).map((item, index) => (
              <Item key={index} item={item} />
            ))}
          </div>
        ) : (
          <div
            style={{
              width: 350,
              height: 214,
              borderRadius: 12,
              background: '#eee',
              padding: '15px 12px'
            }}
          />
        )}
      </Rowbox>
    ) : null
  }
}
